export default __webpack_public_path__ + "static/media/3_2.351c4282.png";